export const connectEruda = () => {
  const script = document.createElement('script');
  script.src = '//cdn.jsdelivr.net/npm/eruda';
  script.async = true;
  script.onload = () => {
    window.eruda.init();
  };

  document.body.appendChild(script);
};
